import "./AmSubHome.scss";
import CircularButton, { CustomLoadingButton } from "../../../components/ui/CustomButton";
import newRequest from "../../../utils/newRequest";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import RefreshIcon from "@mui/icons-material/Refresh";
import { FiSearch } from "react-icons/fi";
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
} from "@mui/material";
import { motion } from "framer-motion";
import moment from "moment";
import numeral from "numeral";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ScaleLoader } from "react-spinners";
import { FaSub } from "react-icons/fa";
import { IoClose, IoDocumentTextSharp } from "react-icons/io5";
import VideoPlayer from "../../../components/videoPlayer/VideoPlayer";
import WorkedOnBy from "../../../components/workedOnBy/WorkedOnBy";
import { useTranslation } from "react-i18next";
import OnScreenReports from "../../../components/onScreenReports/OnScreenReports";
import { MdAdd, MdArrowBackIos, MdClose, MdEmail, MdOutlineNumbers, MdPhone } from "react-icons/md";
import { getCssValue } from "../../../utils/genericFunctions";
import { IoIosRefresh } from "react-icons/io";
import { CiImageOn } from "react-icons/ci";
import Announcements from "../../../components/announcement/Announcements";


const AmSubHome = () => {
  const { t } = useTranslation();
  const { currentUser } = useSelector((state) => state.user);
  const { currentTheme } = useSelector((state) => state.theme);
  const navigate = useNavigate();
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [subscriptions, setSubscriptions] = useState([]);
  const [selectedSubscription, setSelectedSubscription] = useState(null);
  const [reportGroupArray, setReportKeysArray] = useState(["amsub-reports"]);
  const [reportsDialogOpen, setReportsDialogOpen] = useState(false);
  const location = useLocation();
  const showBack = location.state?.showBack || "N";

  const fetchSubscriptions = async () => {
    try {
      setIsLoading(true);
      // Simulate delay for 5 seconds
      // await new Promise((resolve) => setTimeout(resolve, 5000));
      const res = await newRequest.post("/fundSub/findAll", { result_limit: 4 });
      setSubscriptions(res.data);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchSubscriptions();
  }, []);

  const handleOpenOverlay = () => {
    setIsOverlayOpen(true);
  };


  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 5));
    setCurrentPage(0);
  };

  const handleClearSearch = () => {
    setSearchTerm("");
  };

  const filteredSubsData = subscriptions.filter(
    (item) =>
      item?.hd_no?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item?.investor_name_xx?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item?.investor_code_xx?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item?.hd_ref_no?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const paginatedSubscriptions = filteredSubsData?.slice(
    currentPage * rowsPerPage,
    currentPage * rowsPerPage + rowsPerPage
  );

  const handleSearchSubs = async () => {
    try {
      setIsLoading(true);
      if (searchTerm) {
        const res = await newRequest.post("/fundSub/search", { search_input: searchTerm });
        setSubscriptions(res.data);
      } else {
        fetchSubscriptions();
      }
    } catch (error) {
      console.error("Error searching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <motion.div
      className="am-sub-home"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
      exit={{ opacity: 0, transition: { duration: 1 } }}
    >
      {isLoading ? (
        <div className="no-content">
            <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
        </div>
      ) : (
        <motion.div
          className="am-sub-wrapper"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}>
          <div className="am-sub-center-wrapper">
            <div className="center-navbar">
              <div className="navbar-left">{t('subscriptions').toUpperCase()}</div>
              <div className="navbar-right">
                <CustomLoadingButton
                  currentTheme={currentTheme}
                  iconPosition="end"
                  borderRadiusType="left"
                  endIcon={<IoIosRefresh />} onClick={fetchSubscriptions}>
                  {t('refresh')}
                </CustomLoadingButton>
                <CustomLoadingButton
                  currentTheme={currentTheme}
                  iconPosition="end"
                  borderRadiusType="none"
                  endIcon={<IoDocumentTextSharp />}
                  onClick={() => setReportsDialogOpen(true)}>
                  {t('reports')}
                </CustomLoadingButton>
                <CustomLoadingButton
                  endIcon={<MdAdd />}
                  iconPosition="end"
                  borderRadiusType="right"
                  currentTheme={currentTheme}
                  onClick={() => {
                    try {
                      navigate(`/amsubs/new`);
                    } catch (error) {
                      console.log(error)
                    }
                  }}
                >
                  {t('newSubscription')}
                </CustomLoadingButton>
              </div>
            </div>
            <div className="center-content">
              <div className="table-content">
                <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                  <Table sx={{ width: "max-content", border: 'none' }}>
                    <TableHead className="tablehead">
                      <TableRow className="tablerow">
                        <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                          #
                        </TableCell>
                        <TableCell className="table-cell left" style={{ maxWidth: "80px" }}>
                          <span>{t('no').toUpperCase()}</span>
                        </TableCell>
                        <TableCell className="table-cell left" style={{ width: "auto" }}>
                          <div className="search-input-wrapper" style={{ width: "100%" }}>
                            <FiSearch className="search-input-icon" />
                            <input
                              className="search-input"
                              type="text"
                              placeholder={`${t('search')} ${t('subscription')}`}
                              value={searchTerm}
                              onChange={(e) => setSearchTerm(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === 'Enter') handleSearchSubs();
                              }}
                            />
                            {searchTerm.length > 0 && (
                              <MdClose
                                onClick={async (e) => {
                                  try {
                                    setSearchTerm("");
                                    await fetchSubscriptions();
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }}
                                className="search-input-icon"
                              />
                            )}
                            {searchTerm.length === 0 && (
                              <span className="search-input-icon" />
                            )}
                          </div>
                        </TableCell>
                        <TableCell className="table-cell left" style={{ maxWidth: "300px" }}>
                          <span></span>
                        </TableCell>
                        <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                          <span>{t('status')}</span>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody className="tablebody">
                      {paginatedSubscriptions?.map((row, index) => (
                        <TableRow
                          key={row._id}
                          className={`${selectedSubscription?._id === row._id ? "tablerow current" : "tablerow"}`}
                          onClick={() => {
                            try {
                              setSelectedSubscription(row);
                              navigate(`/amsubs/${row._id}`);
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                        >
                          <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                            {currentPage * rowsPerPage + index + 1}
                          </TableCell>
                          <TableCell className="table-cell left" style={{ maxWidth: "80px" }}>
                            <span className="sub-title">{row?.hd_no}</span>
                          </TableCell>
                          <TableCell className="table-cell left" style={{ width: "auto" }}>
                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                              <div className='current-user-avatar'>
                                <div className="user-wrapper">
                                  {row?.investor_details_xx?.ent_photo_url ? <img src={row?.investor_details_xx?.ent_photo_url} alt="" className='avatar' />
                                    :
                                    <CiImageOn style={{
                                      display: "flex",
                                      width: "30px",
                                      height: "30px",
                                      color: "#ccc",
                                      borderRadius: "50%",
                                      objectFit: "cover"
                                    }} />
                                  }
                                  <div className="user-org-view">
                                    <span className="sub-title nowrap">{row?.investor_details_xx?.ent_name}                                                                        </span>
                                    <span style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "10px" }}>
                                      <MdOutlineNumbers className="icon" />
                                      <h1 className="sub-title xrsmall">{row?.investor_details_xx?.ent_code}</h1>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </TableCell>
                          <TableCell className="table-cell left" style={{ maxWidth: "250px" }}>
                            <div style={{ display: "flex", flexDirection: "row", width: "100%", gap: "5px" }}>
                              <span className={`status ${getCssValue(row?.hd_status)}`} style={{ width: "2px" }} />
                              <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                                <span className="sub-title">{row?.fund_name_xx}</span>
                                <span className="sub-title xrsmall soft" style={{ fontSize: "10px" }}>{row?.fund_code_xx}</span>
                              </div>
                            </div>
                          </TableCell>
                          <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                            <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                              <span className="sub-title">{numeral(row?.hd_fc_amount).format("0,0.00")}</span>
                              <span className="sub-title xrsmall soft" style={{ fontSize: "10px" }}>{row?.hd_cur_code}</span>
                            </div>
                          </TableCell>
                          <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                            <span className={`sub-title xrsmall status ${getCssValue(row?.hd_status)}`}>{row?.hd_status}</span>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  <TablePagination
                    rowsPerPageOptions={[10]}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    component="div"
                    count={subscriptions?.length}
                    rows={subscriptions}
                    page={currentPage}
                    onPageChange={handleChangePage}
                  />
                </TableContainer>
              </div>
            </div>
          </div>
          <div className="facility-claims-right-wrapper">
            <Announcements />
          </div>
        </motion.div>
      )}
      {reportsDialogOpen && (
        <motion.div
          className="overlay-dialog reports"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">{t('reports')}</h1>
              <CircularButton currentTheme={currentTheme} onClick={() => setReportsDialogOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <OnScreenReports
                reportGroupArray={reportGroupArray}
                documentData={{
                  docNo: "1",
                  docType: "AllSubs",
                  docId: "1",
                  clientEmail: "",
                  clientEntCode: "",
                  clientEntName: ""
                }} />
            </div>
          </div>
        </motion.div>
      )}
    </motion.div>
  );
};

export default AmSubHome;
